<div class="wrapper__headerComponent container my-5" *ngIf="mostrarTabla">
  <div class="row align-items-center mb-4">
    <h2 class="text-left h3-tipografia-govco mb-0">{{ 'parametrizacion-entidades.titulo' | translate }}</h2>
  </div>
  <div
    class="accordion-govco my-3"
    *ngFor="let entidad of entidades; let i = index">
    <div class="accordion-item">
      <h3 class="h4-tipografia-govco" [attr.id]="'heading' + i">
        <button
          class="button-accordion-govco editing"
          type="button"
          (click)="verEntidades(entidad)"
          aria-label="Ver detalles entidad">
          <img
            [src]="entidad.logo || '../../../../assets/img/H-DIMAR.png'"
            alt="{{ entidad.entidad }} logo"
            width="40"
            height="40"
            class="logo-icon" />
          <p class="text2-govco mb-0">
            {{ entidad.entidad }}
          </p>
        </button>
      </h3>
    </div>
  </div>
</div>
<div class="container mb-3" *ngIf="!mostrarTabla">
  <div class="d-flex justify-content-between align-items-center mt-5 gap-3 card__profil">
    <button
      class="btn-govco outline-btn-govco"
      (click)="volverTabla()"
      aria-label="Volver a la lista de entidades">
      {{ 'parametrizacion-entidades.volver' | translate }}
    </button>
    <button
      class="btn-govco fill-btn-govco"
      (click)="guardarModificaciones()"
      [disabled]="!entidadForm.valid || !tramitesValidos"
      aria-label="Guardar modificaciones">
      {{ 'parametrizacion-entidades.guardar' | translate }}
    </button>
  </div>
  <div
    class="d-flex flex-column flex-md-row align-items-start justify-content-start mt-5 gap-3 card__profile">
    <h3>{{ entidadSeleccionada.entidad }}</h3>
  </div>
  <div
    class="d-flex flex-column flex-md-row align-items-start justify-content-start mt-5 gap-3 card__profile">
    <div
      class="border__form rounded px-3 py-4 flex-shrink-0 card__profile__left">
      <div class="d-flex flex-column align-items-center gap-3">
        <img [src]="imageSrcLogo || '../../../../assets/img/H-DIMAR.png'" alt="Logo"
             style="max-width: 200px; margin-top: 10px;">
        <div class="d-flex flex-column gap-2">
          <button
            class="btn-govco fill-btn-govco" (click)="openFilePicker()"
            aria-label="Cargar nuevo logo">
            <i aria-hidden="true" class="fa fa-cloud-upload nav-icon"></i>&nbsp;
            {{ 'parametrizacion-entidades.cargue-nuevo-logo' | translate }}
          </button>
          <input #fileInputLogo type="file" style="display: none" (change)="onFileSelected($event)">
        </div>
      </div>
      <div class="d-flex flex-column align-items-center gap-3">
        <img [src]="imageSrcLogoMini || '../../../../assets/img/H-DIMAR.png'" alt="Logo miniatura"
             style="max-width: 80px; margin-top: 10px;">
        <div class="d-flex flex-column gap-2">
          <button
            class="btn-govco fill-btn-govco" (click)="openFilePickerMini()"
            aria-label="Cargar nuevo logo miniatura">
            <i aria-hidden="true" class="fa fa-cloud-upload nav-icon"></i>&nbsp;
            {{ 'parametrizacion-entidades.cargue-nuevo-logo-mini' | translate }}
          </button>
          <input #fileInputLogoMini type="file" style="display: none" (change)="onFileSelectedMini($event)">
        </div>
      </div>
    </div>
    <div class="border__form rounded px-3 py-4 flex-grow-1">
      <div [formGroup]="entidadForm">

        <!-- Campo Nombre Entidad -->
        <div class="row">
          <div class="col-12">
            <div class="form-group required form-label d-flex flex-column flex-md-row align-items-md-center w-100">
              <label for="nombreEntidad" class="form-label text3-tipografia-govco mb-md-0 me-md-3 w-100 w-md-25">
                {{ "parametrizacion-entidades.nombre-entidad"| translate }}
              </label>
              <input
                type="text"
                class="form-control flex-grow-1"
                id="nombreEntidad"
                formControlName="nombreEntidad"
                [placeholder]="entidadText['nombre_entidad_placeholder']"
                [ngClass]="{
              'is-valid': entidadForm.get('nombreEntidad')?.valid && entidadForm.get('nombreEntidad')?.touched,
              'is-invalid': entidadForm.get('nombreEntidad')?.invalid && entidadForm.get('nombreEntidad')?.touched
            }"
              />
              <div class="invalid-feedback" *ngIf="entidadForm.get('nombreEntidad')?.value">
                {{
                  entidadForm.get('nombreEntidad')?.errors?.['maxlength']
                    ? entidadText['nombre-entidad-maxlength']
                    : comunText['nombre-pattern']
                }}
              </div>
              <div *ngIf="entidadForm.get('nombreEntidad')?.errors?.['required']" class="invalid-feedback">
                {{ entidadText['nombre-entidad-required'] }}
              </div>
            </div>
          </div>
        </div>

        <!-- Campo Acrónimo -->
        <div class="row">
          <div class="col-12">
            <div class="form-group required form-label d-flex flex-column flex-md-row align-items-md-center w-100">
              <label for="acronimo" class="form-label text3-tipografia-govco mb-md-0 me-md-3 w-100 w-md-25">
                {{ "parametrizacion-entidades.acronimo"| translate }}
              </label>
              <input
                type="text"
                class="form-control flex-grow-1"
                id="acronimo"
                formControlName="acronimo"
                [placeholder]="entidadText['acronimo_placeholder']"
                [ngClass]="{
              'is-valid': entidadForm.get('acronimo')?.valid && entidadForm.get('acronimo')?.touched,
              'is-invalid': entidadForm.get('acronimo')?.invalid && entidadForm.get('acronimo')?.touched
            }"
              />
              <div class="invalid-feedback" *ngIf="entidadForm.get('acronimo')?.value">
                {{
                  entidadForm.get('acronimo')?.errors?.['maxlength']
                    ? entidadText['acronimo-maxlength']
                    : comunText['nombre-pattern']
                }}
              </div>
              <div *ngIf="entidadForm.get('acronimo')?.errors?.['required']" class="invalid-feedback">
                {{ entidadText['acronimo-required'] }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="entidadSeleccionada.filtrable">
        <h5 class="text-left h3-tipografia-govco mb-0">{{ 'parametrizacion-entidades.nombre-procesos' | translate }}
          :</h5>
        <br>
        <ol>
          <li *ngFor="let item of tiposTramite; let i = index">
            <input
              *ngIf="item.editando"
              class="form-control flex-grow-1"
              maxlength="255"
              [(ngModel)]="item.Nombre_Completo"
              (blur)="terminarEdicionTipoTramite(i)"
              (keyup.enter)="terminarEdicionTipoTramite(i)"
            />
            <span *ngIf="!item.editando" class="flex-grow-1">
              {{ item.Nombre_Completo }}
            </span>
            <button *ngIf="!item.editando" class="btn btn-outline-primary bg-transparent ms-2"
                    (click)="editarTipoTramite(i)"
                    aria-label="Editar nombre del proceso">
              <i class="fa fa-pencil"></i>
            </button>
          </li>
        </ol>
      </div>
    </div>
  </div>
</div>
